import React, { useEffect, useState } from 'react';
import { getStorage, ref, uploadBytesResumable, getDownloadURL } from 'firebase/storage';
import { AssemblyAI } from "assemblyai";
import axios from "axios"
import app from '../firebase.js';

const AudioTranscribe = () => {
    const [audioFile, setAudioFile] = useState(null);
    const [transcribedText, setTranscribedText] = useState('');
    const [isUploading, setIsUploading] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isCopySuccess, setIsCopySuccess] = useState(false);
    const [selectedLanguage, setSelectedLanguage] = useState("en");
    const [sourceLanguage, setSourceLanguage] = useState("en");
    const [translationLanguages, setTranslationLanguages] = useState([]);
    const [uploadProgress, setUploadProgress] = useState(0);
    const [isTranslating, setIsTranslating] = useState(false);

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        setAudioFile(file);
    };

    useEffect(() => {
        const fetchTranslationLanguages = async () => {
            const options = {
                method: 'GET',
                url: 'https://google-translate113.p.rapidapi.com/api/v1/translator/support-languages',
                headers: {
                    'X-RapidAPI-Key': 'google-translate-api key from rapid api',
                    'X-RapidAPI-Host': 'google-translate113.p.rapidapi.com'
                }
            };

            try {
                const response = await axios.request(options);
                // console.log(response.data);
                setTranslationLanguages(response.data);
            } catch (error) {
                console.error('Error fetching translation languages', error);
            }
        };

        fetchTranslationLanguages();
    }, []);

    const handleTranscribe = async () => {
        setIsTranslating(true);
        try {
            setIsLoading(true);
            setIsUploading(true);

            const storage = getStorage(app);
            const fileName = new Date().getTime() + audioFile.name;
            const storageRef = ref(storage, fileName);
            const metadata = { contentType: 'audio/*' };

            const uploadTask = uploadBytesResumable(storageRef, audioFile, metadata);

            uploadTask.on(
                'state_changed',
                (snapshot) => {
                    const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                    setUploadProgress(progress);

                    console.log(`Upload is ${progress}% done`);
                },
                (error) => {
                    console.error('Error uploading audio file to Firebase', error);
                    setIsUploading(false);
                },
                async () => {
                    const audioUrl = await getDownloadURL(uploadTask.snapshot.ref);

                    const client = new AssemblyAI({
                        apiKey: "assembly_ai_key",
                    });

                    const transcribeAudioWithAssemblyAI = async (audioUrl) => {
                        try {
                            const response = await client.transcripts.transcribe({
                                audio: audioUrl,
                            });
 
                            const transcription = response.text;

                            return { transcription };
                        } catch (error) {
                            console.error("Error transcribing audio with AssemblyAI:", error.message);
                            return "";
                        }
                    };

                    const { transcription } = await transcribeAudioWithAssemblyAI(audioUrl);

                    await setTranscribedText(transcription);

                    // const response = await axios.post('http://localhost:8080/api/v1/audio/uploadAudio', {
                    //     fileUrl: audioUrl,
                    //     fileName: fileName,
                    //     transcription: transcription
                    // });

                    setIsUploading(false);
                    setUploadProgress(0);
                }

            );
            setIsLoading(false)
            setIsTranslating(false);
        } catch (error) {
            console.error('Error handling transcription', error);
            setIsUploading(false);
            setUploadProgress(0);
        }
    };

    const handleCopyText = () => {
        navigator.clipboard.writeText(transcribedText);
        setIsCopySuccess(true);
        setTimeout(() => {
            setIsCopySuccess(false);
        }, 3000);
    };

    const handleSaveAsText = async () => {
        const blob = new Blob([transcribedText], { type: 'text/plain' });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = 'extracted_text.txt';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const handleLanguageChange = (languageCode) => {
        setSelectedLanguage(languageCode);;
    };

    const handleTranslate = async () => {
        try {
            setIsTranslating(true);


            // Check if sourceLanguage is different from selectedLanguage
            if (sourceLanguage !== selectedLanguage) {
                const encodedParams = new URLSearchParams();
                encodedParams.set('from', sourceLanguage);
                encodedParams.set('to', selectedLanguage);
                encodedParams.set('text', transcribedText);

                const options = {
                    method: 'POST',
                    url: 'https://google-translate113.p.rapidapi.com/api/v1/translator/text',
                    headers: {
                        'content-type': 'application/x-www-form-urlencoded',
                        'X-RapidAPI-Key': 'google-translate-api key from rapid api',
                        'X-RapidAPI-Host': 'google-translate113.p.rapidapi.com'
                    },
                    data: encodedParams,
                };

                const translationResponse = await axios.request(options);

                const translatedText = translationResponse.data.trans;


                setTranscribedText(translatedText);
                setSourceLanguage(selectedLanguage);
            } else {
                const encodedParams = new URLSearchParams();
                encodedParams.set('from', 'auto');
                encodedParams.set('to', selectedLanguage);
                encodedParams.set('text', transcribedText);

                const options = {
                    method: 'POST',
                    url: 'https://google-translate113.p.rapidapi.com/api/v1/translator/text',
                    headers: {
                        'content-type': 'application/x-www-form-urlencoded',
                        'X-RapidAPI-Key': 'google-translate-api key from rapid api',
                        'X-RapidAPI-Host': 'google-translate113.p.rapidapi.com'
                    },
                    data: encodedParams,
                };

                const translationResponse = await axios.request(options);

                const translatedText = translationResponse.data.trans;

                setTranscribedText(translatedText);
                setSourceLanguage(selectedLanguage);
            }

            setIsTranslating(false);
        } catch (error) {
            console.error('Error translating text', error);
        } finally {
            setIsTranslating(false);
        }
    };

    return (
        <div className="p-8 text-center bg-gradient w-full font-primary mb-10">
            <div className="absolute top-0 left-[55%] overlay-glow2"></div>
            <div className="mb-8 w-[70%] mx-auto">
                <label
                    className={`mb-5 inline-block dark:text-neutral-200 text-4xl text-light text-center font-bold my-3 ${isLoading && 'cursor-not-allowed'}`}
                    htmlFor="audioFile"
                >
                    Choose An Audio File
                </label>
                <input
                    className="relative m-0 block w-full min-w-0 flex-auto cursor-pointer rounded border border-solid border-neutral-300 bg-clip-padding px-3 py-[0.32rem] font-normal leading-[2.15] text-neutral-700 transition duration-300 ease-in-out file:-mx-3 file:-my-[0.32rem] file:cursor-pointer file:overflow-hidden file:rounded-none file:border-0 file:border-solid file:border-inherit file:bg-neutral-100 file:px-3 file:py-[0.32rem] file:text-neutral-700 file:transition file:duration-150 file:ease-in-out file:[border-inline-end-width:1px] file:[margin-inline-end:0.75rem] hover:file:bg-neutral-200 focus:border-primary focus:text-neutral-700 focus:shadow-te-primary focus:outline-none dark:border-neutral-600 dark:text-neutral-200 dark:file:bg-neutral-700 dark:file:text-neutral-100 dark:focus:border-primary disabled:cursor-wait"
                    type="file"
                    id="audioFile"
                    accept="audio/*"
                    onChange={handleFileChange}
                    disabled={isUploading || isLoading}
                />

            </div>

            {isUploading && (
                <div className="text-light mb-4 disabled:cursor-wait">
                    Uploading... {uploadProgress.toFixed(2)}% complete
                </div>
            )}

            <button
                className="primary-color text-white p-4 rounded-md mb-8 disabled:cursor-wait font-semibold"
                onClick={handleTranscribe}
                disabled={!audioFile || isUploading || isLoading}
            >
                Transcribe to Text
            </button>

            {(uploadProgress === 100 || isLoading) && (
                <div className="text-white mb-4">
                    Transcribing...
                </div>
            )}

            <div className="bg-gray-100 p-8 mb-8 text-left rounded-md w-[85%] mx-auto">
                <div className="mb-4">
                    <label className="mr-2 font-semibold">Transcribed Text:</label>
                    <div
                        className={`border border-[#ad53e5] p-4 rounded-md h-40 overflow-auto ${isCopySuccess ? 'bg-green-100' : ''
                            }`}
                    >
                        {transcribedText}
                    </div>

                    {transcribedText && (
                        <div className='flex flex-row gap-2'>
                            <button
                                onClick={handleCopyText}
                                className={`text-white bg-blue-500 px-4 py-2 rounded-md mt-4 ${isCopySuccess ? 'cursor-not-allowed' : 'cursor-pointer'
                                    }`}
                                disabled={isCopySuccess || isLoading}
                            >
                                {isCopySuccess ? 'Copied!' : 'Copy Text'}
                            </button>
                            <button
                                onClick={handleSaveAsText}
                                className={`text-white bg-green-500 px-4 py-2 rounded-md mt-4 ${isCopySuccess ? 'cursor-not-allowed' : 'cursor-pointer'
                                    }`}
                                disabled={!transcribedText || isLoading}
                            >
                                {isUploading ? 'Saved!' : 'Save as Text'}
                            </button>
                        </div>
                    )}
                </div>
            </div>

            <div className="w-[100%] flex flex-wrap flex-col gap-4 md:gap-1 md:flex-row items-center justify-center mb-8">
                {/* <label className="mr-2 hidden">Select Language:</label> */}
                <select
                    value={selectedLanguage}
                    onChange={(e) => handleLanguageChange(e.target.value)}
                    className="px-4 py-2 border border-gray-300 rounded-md max-sm:px-2 max-sm:py-1"
                    disabled={isUploading || !transcribedText || isTranslating}
                >
                    {translationLanguages.map((languageObj) => (
                        <option key={languageObj.code} value={languageObj.code}>
                            {languageObj.language}
                        </option>
                    ))}
                </select>
                <button
                    className="bg-gradient2 font-semibold text-white px-6 py-3 ml-2 max-sm:mt-3 rounded-md"
                    onClick={handleTranslate}
                    disabled={!transcribedText || isUploading || isTranslating}
                >
                    {isTranslating ? 'Translating...' : 'Translate'}
                </button>
            </div>

            {isUploading && <div className="text-gray-500">Uploading...</div>}
        </div>
    );
};

export default AudioTranscribe;
